import { isEmpty } from 'lodash';
import { BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES } from 'modules/campaignIndex/constants';
import { ExperimentVariant } from 'modules/graphql/types';
import { Badge } from 'ui/badge';
import { ExperimentFlask } from 'ui/icons';
import { Tooltip } from 'ui/tooltip';
import { getCampaignEditorLinkWithExperimentTakeover } from 'utils/appRoutes';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';

import { useCampaignQueryContext } from '../../context/CampaignQueryContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { useExperimentVariantsById } from '../../hooks/useExperimentVariantsById';
import { getDoesCampaignHaveExperiments, getExperimentAttributeFromCampaign } from '../utils';
import { TemplateDetailsBlock, TemplateDetailsLink } from './EditableHeader.styled';
import { SubHeaderLocales } from './SubHeaderLocales';

export const SubHeaderCampaignFlow = () => {
  const { campaign } = useCampaignQueryContext();
  const { campaignId, templateId } = useQueryParamContext();

  const { liveTemplate } = useEditableFieldsContext();
  const { locales } = useLocaleSettingsContext();
  const experimentId = getExperimentAttributeFromCampaign(campaign, 'id') as number;
  const variants: ExperimentVariant[] = useExperimentVariantsById(experimentId);
  const isCampaignFlow = !!campaignId;

  return (
    <>
      <TemplateDetailsBlock>{campaign.campaignTypeDefinition}</TemplateDetailsBlock>

      {isCampaignFlow && (
        <TemplateDetailsBlock>{`Campaign ID: ${campaign.id}`}</TemplateDetailsBlock>
      )}
      {isCampaignFlow && !!templateId && (
        <TemplateDetailsBlock>
          <Tooltip isUnderlined tooltipContent={liveTemplate.name}>
            Template ID: {templateId}
          </Tooltip>
        </TemplateDetailsBlock>
      )}

      {!isEmpty(locales) && <SubHeaderLocales />}
      {getDoesCampaignHaveExperiments(campaign) && (
        <TemplateDetailsBlock>
          <>
            <ExperimentFlask />
            <TemplateDetailsLink
              href={getCampaignEditorLinkWithExperimentTakeover(campaign.id, experimentId)}
              target="_blank"
            >{`${variants.length} Experiment Variant${
              variants.length > 1 ? 's' : ''
            }`}</TemplateDetailsLink>
          </>
        </TemplateDetailsBlock>
      )}
      <TemplateDetailsBlock>
        <Badge variant={BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES[campaign.campaignState]}>
          {campaign.campaignState}
        </Badge>
      </TemplateDetailsBlock>
    </>
  );
};
